import { useState, useEffect, useCallback } from 'react';
import Card from '../../../components/Card/Card';
import { useParams, useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import NewsLetterForm from './NewsLetterForm';
import { getNewsLetterById, createNewsLetter, updateNewsLetter } from '../../../services/AppManagement/NewsLetterService';
import { getSessions } from '../../../services/SessionService';
import Loader from '../../../components/Loader/Loader';

const NewsLetterManage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [issue, setIssue] = useState('');
  const [title, setTitle] = useState('');
  const [session, setSession] = useState('');
  const [newsletter_file, setNewsletterFile] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const id = params.id;
  const [sessionData, setSessionData] = useState([]);

  const getUniqueNewsLetter = useCallback(async () => {
    try {
      const response = await getNewsLetterById(id);
      if (response.status === 200) {
        const data = response.data.data;
        setTitle(data.title);
        setIssue(data.issue);
        setSession(data.session);
        setNewsletterFile(data.newsletter_file);
      }
    } catch (error) {
      console.error(error);
    }
  }, [id]);

  const fetchSessionList = useCallback(async () => {
    try {
      const response = await getSessions();
      if (response.success) {
        const data = response.data.map(session => ({
          id: session.name,
          name: session.name
        }));
        setSessionData(data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getUniqueNewsLetter();
    }
    fetchSessionList();
  }, [fetchSessionList, getUniqueNewsLetter, id]);

  const changeHandler = (event) => {
    const { name, value } = event.target;
    if (name === 'title') {
      setTitle(value);
    }
    else if (name === 'issue') {
      setIssue(value);
    }
    else if (name === 'session') {
      setSession(value);
    }
  };

  const fileUploadHandler = (e) => {
    const file = e.target.files[0];
    setNewsletterFile(file);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const session_id = localStorage.getItem('session_id');
    const formData = new FormData();
    formData.append('title', title);
    formData.append('issue', issue);
    formData.append('session', session);
    formData.append('newsletter_file', newsletter_file);
    formData.append('session_id', session_id);

    try {
      setIsLoader(true);
      const response = id
        ? await updateNewsLetter(id, formData)
        : await createNewsLetter(formData);
      if (response.status === 200) {
        let msg = response.data.message.success;
        enqueueSnackbar(msg, { variant: 'success' });
        navigate('/newsletter/list');
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setIsLoader(false);
    }
  };
  const back = () => {
    navigate('/newsletter/list');
  };

  return (
    <Card componentName={id ? 'Update NewsLetter' : 'Add NewsLetter'} back={back}>
      {isLoader ? <Loader /> : null}
      <NewsLetterForm
        submitHandler={handleSubmit}
        changeHandler={changeHandler}
        fileUploadHandler={fileUploadHandler}
        sessionData={sessionData}
        issue={issue}
        title={title}
        session={session}
        newsletter_file={newsletter_file}
        id={id}
      />
    </Card>
  );
};
export default NewsLetterManage;
